import { Registration } from '~/Api/Analytics/VirtualBrand/Registration';

import ActionTypes from './ActionTypes';

export interface RegistrationState {
	request: Promise<any>;
	isFething: boolean;
	registration: Registration | null;
}

export interface State {
	byId: { [key: string]: RegistrationState };
}

type Action =
	| {
			type: ActionTypes.request;
			request: Promise<any>;
			id: string;
	  }
	| {
			type: ActionTypes.receive;
			request: Promise<any>;
			id: string;
			registration: Registration | null;
	  };

function createState(): State {
	return {
		byId: {},
	};
}

export default function reducer(state: State = createState(), action: Action): State {
	switch (action.type) {
		case ActionTypes.request:
			return {
				...state,
				byId: {
					...state.byId,
					[action.id]: {
						request: action.request,
						isFething: true,
						registration: null,
					},
				},
			};

		case ActionTypes.receive: {
			const registrationState = state.byId[action.id];
			if (registrationState.request !== action.request) {
				return state;
			}
			if (!action.registration) {
				const byId = { ...state.byId };
				delete byId[action.id];
				return { ...state, byId };
			}

			return {
				...state,
				byId: {
					...state.byId,
					[action.id]: {
						...registrationState,
						isFething: false,
						registration: action.registration,
					},
				},
			};
		}

		default:
			return state;
	}
}

export function selectRegistrationById(state: State, id: string): RegistrationState | null {
	return state.byId[id] || null;
}
